






















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import ImgPreview from "@/components/common/upload/ImgPreview.vue";
import ProfileImgUploader from "@/components/common/upload/ProfileImgUploader.vue";
import BannerImgUploader from "@/components/common/upload/BannerImgUploader.vue";
import { User } from "@/types";
@Component({
    computed: { ...mapGetters(["user"]) },
    components: { ImgPreview, ProfileImgUploader, BannerImgUploader },
    mixins: [validationMixin],
    validations: {
        form: {
            groupName: {
                required,
                maxLength: maxLength(50),
            },
            // groupUrl: {
            //     required,
            //     maxLength: maxLength(50),
            // },
            description: {
                required,
                maxLength: maxLength(2000),
            },
        },
    },
})
export default class CommunitySetting extends Vue {

    private form = {
        groupName: "",
        description: "",
        isPrivate: false,
        // groupUrl: "",
        // managerUid: "",
        bannerImgSrc: "",
        profileImgSrc: "",
    };

    private user!: User;
    private communityId = parseInt(this.$route.params.community_id);
    private community: any;
    private description: string = "";
    private communityName: string = "";
    // private communityMember: string

    private filename: string = "";
    private imgType: string = "";
    private isDescError: boolean = false;
    private isNameError: boolean = false;

    private memberList: User[] = [];
    private managerInfo: User = {} as User;
    private selectedManager: string = "";

    async created() {
        // this.community = this.$api.getCommunityInfo(this.communityId);
        this.form.groupName = this.community.name;
        this.form.description = this.community.description;
        this.form.isPrivate = this.community.is_private;
        // this.memberList = this.$api.communityMembers(this.communityId);
        // this.managerInfo = await this.$api.getUserInfo(
        //     this.community.manager_uid
        // );
        this.selectedManager = this.managerInfo.uid;
        this.form.bannerImgSrc = this.community.banner_img;
        this.form.profileImgSrc = this.community.profile_img;
    }

    validateState(name) {
        const { $dirty, $error } = this.$v.form[name]!;
        return $dirty ? !$error : null;
    }
    mounted() {
        this.description = this.community.description;
        this.communityName = this.community.name;
    }
    selectManager(e) {
        this.selectedManager = e;
    }

    async saveCommuInfo(event) {
        event.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
            return;
        }
        console.log(
            this.selectedManager,
            this.communityId,
            this.form.groupName,
            this.form.description,
            this.form.isPrivate,
            this.form.bannerImgSrc,
            this.form.profileImgSrc
        );
        // const result = this.$api.modifiedCommunityInfo(
        //     this.communityId,
        //     this.form.groupName,
        //     this.form.description,
        //     this.form.isPrivate,
        //     this.form.profileImgSrc,
        //     this.form.bannerImgSrc
        // );
        // console.log(result);
        // if (result === true) {
        // }
    }
    // deleteCommunity() {
    //     const result = this.$api.deleteCommunity(this.communityId);
    // }

    @Watch("description")
    watchChar() {
        if (this.description.length > 2000) {
            this.description = this.description.substring(0, 2000);
            this.isDescError = true;
        } else if (this.description.length < 2000) {
            this.isDescError = false;
        }
    }

    @Watch("communityName")
    watchCommuName() {
        if (this.communityName.length > 50) {
            this.communityName = this.communityName.substring(0, 50);
            this.isNameError = true;
        } else if (this.communityName.length < 50) {
            this.isNameError = false;
        }
    }
    getBannerImgSrc(imgSrc: string) {
        this.form.bannerImgSrc = imgSrc;
    }
    getProfileImgSrc(imgSrc: string) {
        this.form.profileImgSrc = imgSrc;
    }
}
